import React from "react";
import FinGroupMaster from './FinGroup_Master';

const FinGroupApp = () =>{
    return (

    <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{borderRadius: '8px'}}>
          <div className="card-header-css" style={{borderRadius: '8px', textAlign: 'center' }} >
            <h5>Groups</h5>
          </div>
        </div>
        <FinGroupMaster />
      </div>
    </div >
  );
};

export default FinGroupApp;
